import React, { useEffect, useState } from "react";
import { Form, Button, InputGroup } from "react-bootstrap";
import { FaSearch, FaTimes } from "react-icons/fa";
import GridHelper from "../helpers/gridHelper";
import { useLocation, useNavigate } from "react-router-dom";

function ConnectorGridFilter(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (props.filter) {
      setSearchText(props.filter.description ?? "");
    }
  }, [props.filter?.description]);

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      GridHelper.handleSearch({ description: searchText }, location, navigate);
    }
  };

  const handleSearch = () => {
    GridHelper.handleSearch({ description: searchText }, location, navigate);
  };

  const handleClear = () => {
    setSearchText("");
    props.onClearFilters();
  };

  return (
    <div className="mb-3">
      <InputGroup>
        <InputGroup.Text>
          <FaSearch />
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder="Search connectors by description or system..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={onKeyDown}
        />
        {searchText && (
          <Button variant="outline-secondary" onClick={handleClear}>
            <FaTimes />
          </Button>
        )}
        <Button variant="primary" onClick={handleSearch}>
          Search
        </Button>
      </InputGroup>
    </div>
  );
}

export default ConnectorGridFilter;
